export const SHIPPING_METHOD_TAG_DONE = 'SHIPPING_METHOD_DONE';
export const SHIPPING_METHOD_TAG_PICKUP_SELECTED =
  'SHIPPING_METHOD_PICKUP_SELECTED';
export const SHIPPING_METHOD_TAG_COURIER_SELECTED =
  'SHIPPING_METHOD_COURIER_SELECTED';
